export const formatToRub = (value?: number): string => (value ? `${value.toLocaleString('ru')}` : '');

const REMOVE_CHARS_MAP: Record<string, string> = {
  '&nbsp;': ' ',
  '\u00A0': ' ',
  '&mdash;': '-',
  '\u2014': '-',
  '\n': ' ',
};

const HTML_TO_JS_CHARS_MAP: Record<string, string> = {
  '&nbsp;': '\u00A0',
  '&mdash;': '\u2014',
};

/**
 * Заменяет специальные символы HTML/JS(неразрывный пробел, тире и т.д) на их стандартную интерпретацию
 * @param {string} str
 * @return {string}
 */
export const removeSpecialCharacters = (str: string) =>
  str.replace(/&nbsp;|&mdash;|\\u00A0|\\u2014|\n/gm, (matched: string) => REMOVE_CHARS_MAP[matched]);

/**
 * Заменяет специальные символы HTML(неразрывный пробел, тире и т.д) на их JS интерпретацию
 * @param {string} str
 * @return {string}
 */
export const replaceSpecialChars = (str: string) =>
  str.replace(/&nbsp;|&mdash;/gm, (matched: string) => HTML_TO_JS_CHARS_MAP[matched]);
